import { http } from "api/http";

interface ServiceDescriptionItem {
  description: string;
  hsnSac: string;
  gstRate: string;
  serviceFee: string;
}

const getServiceDescriptions = ({ queryKey }) => {
  const { limit, offset, sort, search } = queryKey[1] || {};

  return http.get("/billing-entities/service-descriptions", {
    params: {
      limit,
      offset,
      sort,
      search,
    },
  });
};

const createServiceDescriptions = (data: { serviceDescriptions: ServiceDescriptionItem[] }) => {
  return http.post("/billing-entities/service-descriptions", data);
};

const updateServiceDescription = ({ id, data }: { id: number; data: ServiceDescriptionItem }) => {
  return http.patch(`/billing-entities/service-descriptions/${id}`, data);
};

const deleteServiceDescription = (id: number) => {
  return http.delete(`/billing-entities/service-descriptions/${id}`);
};

const bulkDeleteServiceDescriptions = ({ ids }: { ids: number[] }) => {
  return http.post(`/billing-entities/service-descriptions/bulk-delete`, { ids });
};

const exportServiceDescriptions = async ({ search }: { search?: string }): Promise<Blob> => {
  const response = await http.get("/billing-entities/service-descriptions/export", {
    params: { search },
    responseType: "blob",
  });
  return response.data;
};

const importServiceDescriptions = (data: FormData) => {
  return http.post("/billing-entities/service-descriptions/import", data);
};

export {
  getServiceDescriptions,
  createServiceDescriptions,
  updateServiceDescription,
  deleteServiceDescription,
  bulkDeleteServiceDescriptions,
  exportServiceDescriptions,
  importServiceDescriptions,
};
